module.exports = __webpack_public_path__ + "img/val4icon1.c1f8ef13.png";